import { FC } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import StylesMain from "../components/StyleMain";
import AttendancePanel from "./AttendancePanel";
import CameraCapture from "./CameraCapture";
import ClockHistory from "./ClockHistory";
import CurrentStatusTracking from "./CurrentStatusTracking";
import { useDispatch } from "react-redux";
import { setIsMobileMenuOpen } from "@lhd/components/CommonLayout/sidebarSlice";
import { ROUTES } from "@lhd/constants";
import useTrackingTime, { Props, ReceivedProps } from "./hook";
import SelectCompany from "./SelectCompany";
import StatusTracking from "./StatusTracking";
import { Styles } from "./styled";
import HeaderTitle from "../components/HeaderTitle";
import { Button } from "antd";
import { Note } from "@lhd/assets";
import DigitalClock from "./DigitalClock";
import { BUTTONS_ACTION } from "./contants";
import ButtonAction from "./AttendancePanel/ButtonAction";

const TrackingTimeLayout: FC<Props> = (props) => {
  const isMobileOrTablet = isMobile || isTablet;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const moveToListPage = () => {
    if (!canOpenAttendanceManagement) return;
    window.open(
      `${ROUTES.TRACKING_TIME}${ROUTES.LIST}?isDisplayInNewTab=true`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const {
    workerLogtimesData,
    currentTimeData,
    serverNowMs,
    handleCheckIn,
    isLoading,
    disableBtns,
    isOpenCamera,
    handleOkCamera,
    handleOpenOrCloseCamera,
    typeLogOpenCamera,
    canOpenAttendanceManagement,
    monthHistory,
    setMonthHistory,
    historyTrackingTimes,
    isLoadingHistoryTrackingTimes,
  } = props;

  return (
    <StylesMain isLoading={!!isLoading}>
      {isOpenCamera ? (
        <CameraCapture
          handleOkCamera={handleOkCamera}
          handleOpenOrCloseCamera={handleOpenOrCloseCamera}
          typeLogOpenCamera={typeLogOpenCamera}
        />
      ) : (
        <Styles
          style={{
            minHeight: window.screen.height - 300,
          }}
        >
          {isMobileOrTablet && (
            <>
              <HeaderTitle
                title={"BizTreasure"}
                subTitle="打刻アプリ"
                className="mb-24px"
                onTitleClick={() => {
                  if (isMobileOrTablet) {
                    dispatch(setIsMobileMenuOpen(true));
                    navigate(`/${ROUTES.CORRELATION_DIAGRAM}`);
                  }
                }}
              />
              <DigitalClock
                className="mb-1"
                currentTimeData={currentTimeData}
                workerLogtimesData={workerLogtimesData}
                serverNowMs={serverNowMs}
              />
              <div className="select-button mb-24px">
                <SelectCompany workerLogtimesData={workerLogtimesData} />
                <Button
                  icon={<Note />}
                  className="attendance-management-btn"
                  disabled={!canOpenAttendanceManagement}
                  onClick={moveToListPage}
                >
                  勤怠管理
                </Button>
              </div>
              <StatusTracking
                className="mb-3"
                workerLogtimesData={workerLogtimesData}
                currentTimeData={currentTimeData?.data}
                datetimeWithTimeRes={currentTimeData?.datetimeWithTimeRes}
                isMobileOrTablet={isMobileOrTablet}
              />

              <div className="container_button_action_and_list">
                <div className="container_button_action mb-3">
                  {BUTTONS_ACTION.map((x) => {
                    const keyOfDisableBtns =
                      x.log_type as keyof typeof disableBtns;
                    return (
                      <ButtonAction
                        disabled={
                          disableBtns && !!disableBtns[keyOfDisableBtns]
                        }
                        key={x.label}
                        style={x.style}
                        onClick={() => {
                          handleCheckIn(x.log_type);
                        }}
                      >
                        <span>{x.label}</span>
                      </ButtonAction>
                    );
                  })}
                </div>
                <ClockHistory
                  workerLogtimesData={workerLogtimesData}
                  isMobileOrTablet={isMobileOrTablet}
                />
              </div>
            </>
          )}
          {!isMobileOrTablet && (
            <div className="full-w max-w-1040">
              <StatusTracking
                workerLogtimesData={workerLogtimesData}
                isMobileOrTablet={false}
              />
              <AttendancePanel
                className="mb-1"
                currentTimeData={currentTimeData}
                serverNowMs={serverNowMs}
                disableBtns={disableBtns}
                onCheckIn={handleCheckIn}
              />
              {/* <div className="d-flex align-items-center justify-content-center">
            <IoInformationCircle fontSize={20} className="red-icon" />
            <span>2026年○月○日の出勤／退勤記録がありません。</span>
          </div> */}

              <CurrentStatusTracking
                workerLogtimesData={workerLogtimesData}
                currentTimeData={currentTimeData}
                serverNowMs={serverNowMs}
              />
              <div className="container_button_action_and_list">
                <ClockHistory
                  historyTrackingTimes={historyTrackingTimes?.records}
                  monthHistory={monthHistory}
                  setMonthHistory={setMonthHistory}
                  isLoadingHistoryTrackingTimes={isLoadingHistoryTrackingTimes}
                  canOpenAttendanceManagement={canOpenAttendanceManagement}
                />
              </div>
            </div>
          )}
        </Styles>
      )}
    </StylesMain>
  );
};

const TrackingTime: FC<ReceivedProps> = (props) => (
  <TrackingTimeLayout {...useTrackingTime(props)} />
);

export default TrackingTime;
